export default __webpack_public_path__ + "static/media/screenshot2.a7483433.jpg";